import { FC } from 'react';

export type AdminSettingsProps = {
  backendStartFailed?: boolean;
};

export type SuperUserSettingsProps = {
  onSuccess?: () => void;
};

let AdminSettings: FC<AdminSettingsProps>;
let SuperUserPasswordSetter: FC<SuperUserSettingsProps>;
let SuperUserLoginForm: FC<SuperUserSettingsProps>;
let _isSuperUserNeedSetting: boolean;

export function setAdminSettings(settings: FC<AdminSettingsProps>) {
  AdminSettings = settings;
}

export function getAdminSettings() {
  return AdminSettings;
}

export function setSuperUserPasswordSetter(
  settings: FC<SuperUserSettingsProps>,
) {
  SuperUserPasswordSetter = settings;
}

export function getSuperUserPasswordSetter() {
  return SuperUserPasswordSetter;
}

export function setSuperUserLoginForm(form: FC<SuperUserSettingsProps>) {
  SuperUserLoginForm = form;
}

export function getSuperUserLoginForm() {
  return SuperUserLoginForm;
}
